import { StoreData } from '@/types'

import { ApiResponse } from '@/types'
import apiClient from '@/utils/apiClient'

const storeApi = {
    getStoreDetails: async () => {
        const response = await apiClient.get<ApiResponse<StoreData>>(
            `/onboarding/store/details`
        )
        return response.data.data
    },
}

export default storeApi
